import { generateSeoProps } from '../generateSeoProps';

export const getToolkitsProps = () => {
    return generateSeoProps({
        title: 'Pharmuni Toolkit: SOPs, Calculators & Quick Guides for Pharma Professionals',
        canonical: 'toolkits',
        noIndex: false,
        description: `Explore practical pharma tools — ready-to-use SOP templates, GMP checklists, calculators and quick guides to help you work faster and stay compliant.`,
    });
};

export const getToolkitDynamicProps = ({ title = '', description = '', id = '', slug = '', image = '' }) => {
    return generateSeoProps({
        title: `${title} - Pharmuni Toolkit`,
        description: description,
        canonical: `toolkits/${id}/${slug}`,
        noIndex: false,
        image: image
    });
};
